import {
	WhiteSpace,
	SecPolygons,
	PopulationHeatMap,
	CellSites,
	PopulationGrid,
	AreaPolygon,
	UrbanizationPolygonsServices,
	DailyTrafficDataService,
	TargetedConsumerService,
	DigitalPersonaDataService,
	DemographicPopulationDensityService,
	AdditionalShopsService,
	MotorSportsServices,
	SecDensityService,
	WhiteSpaveDensityService,
	SocialMediaBehaviorsService,
	SmokingZonesService
} from "../Common";
import Functions from "../Common/Functions";
import has from "lodash/has";
import pickBy from "lodash/pickBy";
import get from "lodash/get";
import { flattenDeep, isEmpty, mapValues, pick, uniq, unset } from "lodash";
import cloneDeep from "lodash/cloneDeep";
import shopDensityMap from "./SecDensityMap";
import { days } from "../PolygonsModal/DailyTrafficContent";

const variables = {
	censusShops: "census_shops",
	clientShops: `client_shops`,
	filteredShops: "selected_outlets",
	bat_contracted_outlets: "BAT Contracted outlets",
	bat_contracted_outlets_selected: "BAT Contracted outlets Selected"
};

const selectedPolygonTypes = {
	defaultpolygons: "Normal Polygons",
	whiteSpace: "White Space",
	categoryWhiteSpace: "Category White Space",

	SAWhiteSpace: "Comparison",
	CategorySAWhiteSpace: "CategoryComparison",

	CategoryExpansion: "Category Expansion Polygons",
	Expansion: "Expansion Polygons",
	CategoryExpansionCore: "CategoryExpansionCore",

	SecPolgons: "Shopper Profile",
	populationDensity: "Population Density",
	shopDensity: "Shop Density",

	population: "Population",
	CELLSITES: "Cell Sites",
	PopulationGrids: "Population Grids",
	CELLSITESMAPPING: "CELLSITESMAPPING",
	AreaPolygons: "Land Type Grids",
	UrbanizationPolygons: "Urbanization Polygons",
	DailyTrafficData: "Daily Traffic Data",
	TargetedConsumer: "Targeted Consumer",
	digitalPersona: "Digital Persona",
	// demographic_population_density
	demographicPopulationDensity: "Demographic Population Density",
	additional_shops: "additional_shops",
	motor_spots: "Motor Spots",
	sec_density: "sec_density",
	whiteSpace_density: "whiteSpace_density",
	motor_spots_population: "Motor Spots Population",
	social_media_behaviors: "Social Media Behaviors",
	smoking_zones: "Smoking Zones"
};
const HomeActions = {
	setPolygons: "setPolygons",
	swtichPolygons: "swtichPolygons",
	SecPolygons: "SecPolygons",
	populationDensity: "populationDensity",
	filterPolygons: "filterPolygons"
};
const FilterAdditionalAction = {
	FilterType: "FilterType",
	Reset: "RESET",
	addSection: "ADDSECTION",
	SelectedAll: "SELECTALL",
	EBM_REGIONAL: "shop_data.EBM_REGIONAL_dms_matched",
	TOP_LEVEL_FILTER: "TOP_LEVEL_FILTER",
	loadFilter: "loadFilter",
	SetFlag: "setFlag"
};
const Tenant = {
	EBM_REGIONAL: "EBM_REGIONAL",
	JAZZCASH: "JAZZCASH",
	SUNTORY: "SUNTORY",
	PCI_BOTTLER: "PCI_BOTTLER",
	BAT_KHI: "BAT_KHI",
	ISMAIL_INDUSTRIES: "ISMAIL_INDUSTRIES",
	BAT_UK: "BAT_UK",
	PG_PHL: "PG_PHL",
	BAT_UK_INDEPENDENT: "BAT_UK_INDEPENDENT",
	PG_KHI: "PG_KHI",
	BAT_UK_INDEPENDENT_V2: "BAT_UK_INDEPENDENT_V2",
	LOREAL: "LOREAL",
	UL_LDM: "UL_LDM",
	nielsen_demo: "NIElSEN_DEMO",
	BAT_ORGANIZED: "BAT_ORGANIZED",
	BAT_GERMANY: "BAT_GERMANY",
	BAT_MALAYSIA: "BAT_MALAYSIA",
	UL_ICECREAM: "UL_ICECREAM",
	RB_PAKISTAN: "RB_PAKISTAN",
	BAT_TENNESSEE: "BAT_TENNESSEE",
	BAT_CZECH: "BAT_CZECH",
	BAT_ITALY: "BAT_ITALY",
	BAT_ROMANIA: "BAT_ROMANIA",
	BAT_HUNGARY: "BAT_HUNGARY",
	BAT_INDONESIA_RTM: "BAT_INDONESIA_RTM",
	BAT_SOUTH_KOREA: "BAT_SOUTH_KOREA",
	BAT_SWITZERLAND: "BAT_SWITZERLAND",
	BAT_ROMANIA_V2: "BAT_ROMANIA_V2",
	BAT_AUSTRIA: "BAT_AUSTRIA",
	BAT_SWEDEN: "BAT_SWEDEN",
	BAT_CROATIA: "BAT_CROATIA",
	BAT_TURKEY: "BAT_TURKEY",
	BAT_UKRAINE: "BAT_UKRAINE",
	BAT_BRAZIL: "BAT_BRAZIL",
	BAT_BULGARIA: "BAT_BULGARIA",
	BAT_SPAIN: "BAT_SPAIN",
	BAT_FRANCE: "BAT_FRANCE",
	BAT_FLORIDA: "BAT_FLORIDA",
	BAT_POLAND: "BAT_POLAND",
	RB_PAKISTAN_V2: "RB_PAKISTAN_V2",
	BAT_NAIROBI: "BAT_NAIROBI",
	BAT_JAPAN: "BAT_JAPAN",
	BAT_GREECE: "BAT_GREECE",
	BAT_KSA: "BAT_KSA",
	BAT_CHILE: "BAT_CHILE",
	BAT_ARGENTINA: "BAT_ARGENTINA",
	BAT_STATES: "BAT_STATES",
	UL_INDONESIA: "UL_INDONESIA"
};

const {
	population,
	populationDensity,
	SAWhiteSpace,
	Expansion,
	SecPolgons,
	whiteSpace,
	CELLSITES,
	CELLSITESMAPPING,
	defaultpolygons,
	PopulationGrids,
	CategoryExpansion,
	CategorySAWhiteSpace,
	categoryWhiteSpace,
	shopDensity,
	CategoryExpansionCore,
	AreaPolygons,
	UrbanizationPolygons,
	DailyTrafficData,
	TargetedConsumer,
	digitalPersona,
	demographicPopulationDensity,
	additional_shops,
	motor_spots,
	whiteSpace_density,
	sec_density,
	social_media_behaviors,
	smoking_zones
} = selectedPolygonTypes;

const { JAZZCASH, SUNTORY, ISMAIL_INDUSTRIES, PG_PHL, BAT_MALAYSIA, BAT_FLORIDA, BAT_STATES } = Tenant;

const defaultFilters = {
	[`${BAT_FLORIDA}-${variables.bat_contracted_outlets_selected}`]: {
		shop_contracted_profile: {
			FilterType: true,
			"outlet_data.bat_contracted_outlet": ["Yes"]
		}
	},
	[`${BAT_FLORIDA}-${variables.bat_contracted_outlets}`]: {
		shop_contracted_profile: {
			FilterType: true,
			"outlet_data.bat_contracted_outlet": ["Yes"]
		}
	},
	[`${BAT_STATES}-${variables.bat_contracted_outlets_selected}`]: {
		shop_contracted_profile: {
			FilterType: true,
			"outlet_data.bat_contracted_outlet": ["Yes"]
		}
	},
	[`${BAT_STATES}-${variables.bat_contracted_outlets}`]: {
		shop_contracted_profile: {
			FilterType: true,
			"outlet_data.bat_contracted_outlet": ["Yes"]
		}
	}
};

const { Error, getLegend } = Functions;
const { filterPolygons, swtichPolygons } = HomeActions;

// Helper functions for equality‐based filtering

/**
 * Returns a new array containing only those polygons
 * whose property (at the given accessor) equals the expected value.
 * If the property is missing, the polygon is included.
 *
 * @param {Array} polygons - an array of polygon objects.
 * @param {string} accessor - the property path (e.g. "filterData.value" or "filterData").
 * @param {*} expected - the expected value for an equality check.
 * @returns {Array} the filtered polygons.
 */
const filterPolygonsByEquality = (polygons, accessor, expected) => {
	// If expected is undefined or null, no filtering is applied.
	if (expected === undefined || expected === null) return polygons;
	return polygons.filter(polygon => {
		if (has(polygon, accessor)) {
			const value = get(polygon, accessor);
			return value === expected;
		}
		// If the property is missing, include the polygon.
		return true;
	});
};

/**
 * Returns a new array where each polygon that does not meet the equality
 * check is returned with modified style and showInfo flag.
 *
 * @param {Array} polygons - an array of polygon objects.
 * @param {string} accessor - the property path (e.g. "filterData.value" or "filterData").
 * @param {*} expected - the expected value for an equality check.
 * @returns {Array} the mapped polygons.
 */
const mapPolygonsByEquality = (polygons, accessor, expected) =>
	polygons.map(polygon => {
		if (has(polygon, accessor)) {
			const value = get(polygon, accessor);
			if (value === expected) return polygon;
			// Modify polygon style and set showInfo to false if value does not match.
			return {
				...polygon,
				style: { ...polygon.style, fillColor: "#FFFFFF11" },
				showInfo: false
			};
		}
		// If the property is missing, leave the polygon unchanged.
		return polygon;
	});

/**
 * Returns a new array containing only those polygons
 * whose property (at the given accessor) falls within the [min, max] range.
 * If the property is missing, the polygon is included.
 *
 * @param {Array} polygons - an array of polygon objects.
 * @param {string} accessor - the property path (e.g. "filterData.value").
 * @param {Array} range - an array [min, max] defining the numeric range.
 * @returns {Array} the filtered polygons.
 */
const filterPolygonsByRange = (polygons, accessor, [min, max]) =>
	polygons.filter(polygon => {
		const value = get(polygon, accessor);
		// If the property is missing, include the polygon.
		return value === undefined || (value >= min && value <= max);
	});

/**
 * Returns a new array where each polygon that does not pass the range check
 * is returned with modified style and showInfo flag.
 *
 * @param {Array} polygons - an array of polygon objects.
 * @param {string} accessor - the property path (e.g. "filterData.value").
 * @param {Array} range - an array [min, max] defining the numeric range.
 * @returns {Array} the mapped polygons.
 */
const mapPolygonsByRange = (polygons, accessor, [min, max]) =>
	polygons.map(polygon => {
		const value = get(polygon, accessor);
		if (value === undefined || (value >= min && value <= max)) {
			return polygon;
		}
		return {
			...polygon,
			style: { ...polygon.style, fillColor: "#FFFFFF11" },
			showInfo: false
		};
	});

const filterPopulationGridsPolygons = ({ polygons, sliderValue }) => {
	if (isEmpty(sliderValue[PopulationGrids])) {
		// Default population filter: allow any value.
		sliderValue[PopulationGrids] = [-Infinity, Infinity];
	}

	const populationFilter = sliderValue[PopulationGrids];
	polygons = filterPolygonsByRange(polygons, "filterData.population", populationFilter);

	return polygons;
};
const filterSecDensityPolygons = ({ polygons, sliderValue }) => {
	const filter = sliderValue[sec_density];
	if (isEmpty(sliderValue[`${PopulationGrids}`])) {
		// Default population filter: allow any value.
		sliderValue[`${PopulationGrids}`] = [-Infinity, Infinity];
	}

	polygons = filterPopulationGridsPolygons({ polygons, sliderValue });

	// const previousSecFilter = previousSliderValues?.[sec_density];
	// const newSecFilter = filter;

	// if (previousSecFilter === newSecFilter) {
	// 	return polygons;
	// }
	return filterPolygonsByEquality(polygons, "filterData.sec", filter);
};

const polygonPassesFilter = ({ polygons, sliderValue, polygonType, previousSliderValues }) => {
	polygons = filterSecDensityPolygons({ polygons, sliderValue, previousSliderValues });

	// Ensure filters is defined
	let filters = sliderValue || {};

	// Set default filters if missing.
	if (isEmpty(filters[`${polygonType}-trafficData`])) {
		// Default hourly traffic value range.
		filters[`${polygonType}-trafficData`] = [0, 100];
	}
	if (isEmpty(filters[`${polygonType}-weeklyData`])) {
		// Default weekly range: [0, 6] covers Monday (0) to Sunday (6)
		filters[`${polygonType}-weeklyData`] = [0, 6];
	}
	if (isEmpty(filters[`${PopulationGrids}`])) {
		// Default population filter: allow any value.
		filters[`${PopulationGrids}`] = [-Infinity, Infinity];
	}
	if (isEmpty(filters[`${polygonType}-hourlyData`])) {
		// Default hourly filter: all hours of the day.
		filters[`${polygonType}-hourlyData`] = [0, 23];
	}

	// Return the polygons that pass the filter criteria.
	return polygons.filter(polygon => {
		// 2. Subset the weekly (day) data:
		const [dayStart, dayEnd] = filters[`${polygonType}-weeklyData`];

		const selectedNames =
			dayStart <= dayEnd
				? days.slice(dayStart, dayEnd + 1)
				: [...days.slice(dayStart), ...days.slice(0, dayEnd + 1)];

		const weeklySubset = polygon?.filterData?.popular_times?.filter(dayObj => {
			return selectedNames.includes(dayObj.name);
		});

		//   const start = (dayStart + 1) % 7;
		// // length of range mod 7, then +1 to be inclusive
		// const len = ((dayEnd - dayStart + 7) % 7) + 1;

		// 	const weeklySubset = polygon?.filterData?.popular_times?.slice(dayStart, dayEnd + 1);

		// 3. Filter the hourly traffic data:
		const [hourStart, hourEnd] = filters[`${polygonType}-hourlyData`];
		// Note: Ensure the key used below is consistent with the default set above.
		const [trafficMin, trafficMax] = filters[`${polygonType}-trafficData`];

		let dayHasValidTraffic = false;
		if (weeklySubset) {
			for (const day of weeklySubset) {
				const hourlyDataSubset = day.data.slice(hourStart, hourEnd + 1);
				if (hourlyDataSubset.some(traffic => traffic >= trafficMin && traffic <= trafficMax)) {
					dayHasValidTraffic = true;
					break;
				}
			}
		} else {
			return true;
		}

		// 4. Only keep the polygon if at least one day has valid traffic data.
		return dayHasValidTraffic;
	});
};

const filterwhiteSpaceDensityPolygons = ({ polygons, sliderValue, previousSliderValues }) => {
	const filter = sliderValue[whiteSpace_density];
	polygons = polygonPassesFilter({
		polygons,
		sliderValue,
		polygonType: DailyTrafficData,
		previousSliderValues
	});

	return filterPolygonsByEquality(polygons, "filterData.flag", filter);
};
const filterDemographicPopulationDensityPolygons = ({
	polygons,
	shopperProfileFilter,
	sliderValue,
	previousSliderValues
}) => {
	polygons = filterwhiteSpaceDensityPolygons({ polygons, sliderValue, previousSliderValues });
	// const lowerFilterLevel = filterLevel?.toLowerCase();
	const [min, max] = sliderValue[demographicPopulationDensity];

	return polygons.filter(polygon => {
		if (shopperProfileFilter)
			for (const [filterKey, selectedValues] of Object.entries(shopperProfileFilter)) {
				const polygonDataArray = polygon[filterKey];

				// Skip if polygon doesn't have this data category
				if (!polygonDataArray?.length) return false;

				// Use the first object in the data array
				const categoryData = polygonDataArray[0];

				// Convert selected values to a Set for faster lookup
				const selectedValuesSet = new Set(selectedValues);

				// If none of the selected values match, filter it out
				// if (![...selectedValuesSet].some(value => categoryData[value]?.toLowerCase() === lowerFilterLevel)) {
				if (![...selectedValuesSet].some(value => categoryData[value] >= min && categoryData[value] <= max)) {
					return false;
				}
			}
		return true;
	});
};

const filterSocialMediaBehaviourPolygons = ({
	polygons,
	shopperProfileFilter,
	sliderValue,
	previousSliderValues,
	filterPreviousPolygons = true
}) => {
	if (filterPreviousPolygons)
		polygons = filterwhiteSpaceDensityPolygons({ polygons, sliderValue, previousSliderValues });
	// const lowerFilterLevel = filterLevel?.toLowerCase();
	const [min, max] = sliderValue[social_media_behaviors];

	return polygons.filter(polygon => {
		if (shopperProfileFilter)
			for (const [filterKey, selectedValues] of Object.entries(shopperProfileFilter)) {
				const polygonDataArray = polygon[filterKey];

				// Skip if polygon doesn't have this data category
				if (!polygonDataArray?.length) return false;

				// Use the first object in the data array
				const categoryData = polygonDataArray[0];

				// Convert selected values to a Set for faster lookup
				const selectedValuesSet = new Set(selectedValues);

				// If none of the selected values match, filter it out
				// if (![...selectedValuesSet].some(value => categoryData[value]?.toLowerCase() === lowerFilterLevel)) {
				if (![...selectedValuesSet].some(value => categoryData[value] >= min && categoryData[value] <= max)) {
					return false;
				}
			}
		return true;
	});
};

export const polygonStartString = {
	[whiteSpace]: "WS",
	[SAWhiteSpace]: "SAWS",
	[populationDensity]: "PD",
	[SecPolgons]: "SEC",
	[population]: "POP",
	[PopulationGrids]: "PG",
	[shopDensity]: "SD",
	[AreaPolygons]: "AP",
	[UrbanizationPolygons]: "UP"
};
let obj = {
	variables,
	defaultFilters,
	polygonStartString,
	HomeActions,
	FilterAdditionalAction,
	Tenant,
	SecColors: {
		A: "#05f505", //  "#00FF00"
		B: "#F50593", //   "#f207bb"
		C: "#f1f505", //   "#439ED6"
		D: "#f58905",
		E: "#f50905",
		AB: "#05f505", //  "#00FF00"
		C1: "#F50593", //   "#f207bb"
		C2: "#f1f505", //   "#439ED6"
		DE: "#f58905"
	},
	getselectedTypeIds: (
		selecteddropDown,
		currentSelectedTypeIndex,
		selectedPolygons,
		CellSiteIds,
		selectedType,
		sliderValue,
		legendValues
	) => {
		let filterData = {};
		let type = selectedType;
		// demographicPopulationDensity
		const {
			CELLSITES,
			SAWhiteSpace,
			PopulationGrids,
			Expansion,
			DailyTrafficData,
			SecPolgons,
			motor_spots,
			whiteSpace_density,
			sec_density,
			demographicPopulationDensity,
			social_media_behaviors
		} = selectedPolygonTypes;
		let selectedTypeIds = selecteddropDown[currentSelectedTypeIndex] || [];
		if ([CELLSITES].includes(selectedPolygons)) {
			selectedTypeIds = CellSiteIds;
			type = "CELL_SITE";
		} else if (
			[
				SAWhiteSpace,
				PopulationGrids,
				Expansion,
				DailyTrafficData,
				SecPolgons,
				motor_spots,
				whiteSpace_density,
				sec_density,
				demographicPopulationDensity,
				social_media_behaviors
			].includes(selectedPolygons)
		) {
			let value = sliderValue[selectedPolygons] || [0, 100];

			if ([SecPolgons].includes(selectedPolygons)) {
				value = legendValues[selectedPolygons];
			}
			filterData = { value, polygonsType: selectedPolygons };
		}

		Object.entries(sliderValue).forEach(([key, value]) => {
			if (key.includes(selectedPolygons)) {
				filterData = { ...filterData, [key]: value };
			}
		});
		return { selectedTypeIds, type, filterData };
	},
	getClientandTenantFilter: Filters => {
		let censusFilter = { ...Filters };
		let tenantData = cloneDeep({ ...censusFilter?.tenant } || {});
		let tenantFilter = {};
		unset(censusFilter, `tenant`);
		if (tenantData) {
			const testKeys = Object.keys(tenantData);
			Object.entries(censusFilter).forEach(([, value]) => {
				if (typeof value === "object") {
					Object.entries(value).forEach(([childKey, childValue]) => {
						if (testKeys.includes(childKey)) {
							if (has(tenantData, childKey)) {
								if (childKey === "FilterType") {
									tenantFilter = {
										...tenantFilter,
										[childKey]: childValue
									};
								} else {
									const { dbKey } = tenantData[childKey];
									// if (value === true) {
									tenantFilter = {
										...tenantFilter,
										[childKey]: {
											FilterType: true,
											[dbKey]: childValue
										}
									};
								}

								// }
							} else {
								unset(tenantData, childKey);
							}
						}
					});
				}
			});
		}

		return { censusFilter, tenantFilter };
	},
	filterPolygon: {
		// For "SecPolgons": modify (via map) using equality on polygon.filterData.value
		[SecPolgons]: ({ filter, polygons }) => mapPolygonsByEquality(polygons, "filterData.value", filter),
		[sec_density]: ({ polygons, sliderValue, previousSliderValues }) => {
			return filterSecDensityPolygons({ polygons, sliderValue, previousSliderValues });
		},
		[whiteSpace_density]: ({ polygons, sliderValue, previousSliderValues }) => {
			return filterwhiteSpaceDensityPolygons({ polygons, sliderValue, previousSliderValues });
		},

		// For "AreaPolygons": filter (keep only matching ones) using equality on polygon.filterData.value
		[AreaPolygons]: ({ filter, polygons }) => filterPolygonsByEquality(polygons, "filterData.value", filter),

		// For "shopDensity": filter based on a numeric range on polygon.filterData.value
		[shopDensity]: ({ filter, polygons }) => filterPolygonsByRange(polygons, "filterData.value", filter),

		// For these keys, if the value is within the range the polygon is kept; otherwise its style is dimmed.
		[SAWhiteSpace]: ({ filter, polygons }) => mapPolygonsByRange(polygons, "filterData.value", filter),

		[Expansion]: ({ filter, polygons }) => mapPolygonsByRange(polygons, "filterData.value", filter),

		[CategorySAWhiteSpace]: ({ filter, polygons }) => mapPolygonsByRange(polygons, "filterData.value", filter),

		[CategoryExpansionCore]: ({ filter, polygons }) => mapPolygonsByRange(polygons, "filterData.value", filter),

		// For these keys the filtering is done on a nested property in "data"
		[CELLSITES]: ({ filter, polygons }) => filterPolygonsByRange(polygons, "data.filterData", filter),

		[PopulationGrids]: ({ polygons, sliderValue }) => filterPopulationGridsPolygons({ polygons, sliderValue }),
		[smoking_zones]: ({ polygons, filter }) => mapPolygonsByRange(polygons, "filterData.value", filter),

		[`${PopulationGrids}-motorSports`]: ({ polygons, sliderValue }) =>
			filterPopulationGridsPolygons({ polygons, sliderValue }),

		[TargetedConsumer]: ({ filter, polygons }) => filterPolygonsByRange(polygons, "data.filterData", filter),

		[digitalPersona]: ({ filter, polygons }) => filterPolygonsByRange(polygons, "data.filterData", filter),

		// DailyTrafficData variants use a custom helper
		[`${DailyTrafficData}-populationData`]: ({ polygons, sliderValue, previousSliderValues }) =>
			polygonPassesFilter({
				polygons,
				polygonType: DailyTrafficData,
				sliderValue,
				previousSliderValues
			}),

		[`${DailyTrafficData}-trafficData`]: ({ polygons, sliderValue, previousSliderValues }) =>
			polygonPassesFilter({
				polygons,
				polygonType: DailyTrafficData,
				sliderValue,
				previousSliderValues
			}),

		[`${DailyTrafficData}-weeklyData`]: ({ polygons, sliderValue, previousSliderValues }) =>
			polygonPassesFilter({
				polygons,
				polygonType: DailyTrafficData,
				sliderValue,
				previousSliderValues
			}),

		[`${DailyTrafficData}-hourlyData`]: ({ polygons, sliderValue, previousSliderValues }) =>
			polygonPassesFilter({
				polygons,
				sliderValue,
				previousSliderValues,
				polygonType: DailyTrafficData
			}),

		[`${DailyTrafficData}`]: ({ polygons, sliderValue, previousSliderValues }) =>
			polygonPassesFilter({
				polygons,
				polygonType: DailyTrafficData,
				sliderValue,
				previousSliderValues
			}),

		// For demographicPopulationDensity we use the custom filtering routine.
		[demographicPopulationDensity]: ({ polygons, sliderValue, previousSliderValues }) => {
			const filters = JSON.parse(localStorage.getItem("userFilters"));
			const shopperProfileFilter = cloneDeep(filters["shopper_profile"]);
			// const filterMapping = { 1: "low", 2: "mid", 3: "high" };
			if (shopperProfileFilter) delete shopperProfileFilter.FilterType;
			return filterDemographicPopulationDensityPolygons({
				polygons,
				shopperProfileFilter,
				previousSliderValues,
				sliderValue
			});
		},

		[social_media_behaviors]: ({ polygons, sliderValue, previousSliderValues }) => {
			const filters = JSON.parse(localStorage.getItem("userFilters"));
			const shopperProfileFilter = cloneDeep(filters["digital_persona"]);
			// const filterMapping = { 1: "low", 2: "mid", 3: "high" };
			if (shopperProfileFilter) delete shopperProfileFilter.FilterType;
			return filterSocialMediaBehaviourPolygons({
				polygons,
				shopperProfileFilter,
				previousSliderValues,
				sliderValue,
				filterPreviousPolygons: true
			});
		},

		// (Assuming the lower-case duplicate key for SecPolgons is not needed)
		[additional_shops]: ({ polygons, filter }) => filterPolygonsByRange(polygons, "data.filterData", filter),

		// For motor_spots variants, we use the custom polygonPassesFilter helper.
		[`${motor_spots}-populationData`]: ({ polygons, sliderValue, previousSliderValues }) =>
			polygonPassesFilter({
				polygons,
				sliderValue,
				polygonType: motor_spots,
				previousSliderValues
			}),

		[`${motor_spots}-trafficData`]: ({ polygons, sliderValue, previousSliderValues }) =>
			polygonPassesFilter({
				polygons,
				sliderValue,
				polygonType: motor_spots,
				previousSliderValues
			}),

		[`${motor_spots}-weeklyData`]: ({ polygons, sliderValue, previousSliderValues }) =>
			polygonPassesFilter({
				polygons,
				sliderValue,
				polygonType: motor_spots,
				previousSliderValues
			}),

		[`${motor_spots}`]: ({ polygons, sliderValue, previousSliderValues }) =>
			polygonPassesFilter({
				polygons,
				polygonType: motor_spots,
				sliderValue,
				previousSliderValues
			}),
		[`${motor_spots}`]: ({ polygons, filter }) => filterPolygonsByRange(polygons, "data.filterData", filter)
	},

	generatePolygons: {
		[UrbanizationPolygons]: ({ data, dispatch, geo }) => {
			const polygons = UrbanizationPolygonsServices.polygons(data);
			const legends = UrbanizationPolygonsServices.legends(data);
			dispatch({
				type: "setObject",
				actions: {
					set: {
						[`allPolygons.${UrbanizationPolygons}.${geo}`]: polygons,
						[`allLegends.${UrbanizationPolygons}`]: legends,
						[`loadingsData.${geo}-${UrbanizationPolygons}`]: false
					}
				}
			});
		},
		[AreaPolygons]: ({ data, dispatch, geo }) => {
			const polygons = AreaPolygon.polygons(data);
			const legends = AreaPolygon.legends(data, key => {
				dispatch({ type: "FilterPolygons", value: { key, geo, selectedPolygonType: AreaPolygons } });
			});
			dispatch({
				type: "setObject",
				actions: {
					set: {
						[`allPolygons.${AreaPolygons}.${geo}`]: polygons,
						[`allLegends.${AreaPolygons}`]: legends,
						[`loadingsData.${geo}-${AreaPolygons}`]: false
					}
				}
			});
		},
		[CELLSITESMAPPING]: ({ data, dispatch, geo }) => {
			dispatch({
				type: "setObject",
				actions: {
					set: {
						[`allPolygons.${CELLSITESMAPPING}.${geo}`]: data
					}
				}
			});
		},
		[CELLSITES]: ({ data, dispatch, geo }) => {
			if (has(data, "locations")) {
				const { locations } = data;
				const { polygons, slider } = CellSites.all({
					locations,
					sliderHandler: async value => {
						await dispatch({ type: filterPolygons, value: { value, type: CELLSITES } });
						dispatch({
							type: "UPDATETABLEDATA"
						});
					}
				});
				dispatch({
					type: "setObject",
					actions: {
						set: {
							[`allPolygons.${CELLSITES}.${geo}`]: polygons,
							[`allSliders.${CELLSITES}.${geo}`]: slider,
							[`loadingsData.${geo}-${CELLSITES}`]: false
						}
					}
				});
			} else {
				Error("Error While Computing Cell Site Polygon");
				dispatch({
					type: "setObject",
					actions: {
						set: {
							[`loadingsData.${geo}-${CELLSITES}`]: undefined
						}
					}
				});
			}
		},
		[whiteSpace]: ({ data, dispatch, geo, tenant }) => {
			if (has(data, "locations")) {
				const { locations } = data;
				const { polygons, legends } = WhiteSpace.all({
					locations,
					range: null,
					filter: null,
					legendHandler: key => {
						dispatch({ type: "FilterPolygons", value: { key, geo, selectedPolygonType: whiteSpace } });
					},
					type: whiteSpace,
					tenant
				});

				const {
					polygons: SApolygons,
					legends: SAlegends,
					slider: SAlider
				} = WhiteSpace.all({
					locations,
					range: null,
					filter: null,
					sliderHandler: value => dispatch({ type: filterPolygons, value: { value, type: Expansion } }),

					legendHandler: key => {
						dispatch({ type: swtichPolygons, polygons: key });
					},
					tenant,
					type: SAWhiteSpace
				});

				const {
					polygons: ExpensionPolygons,
					legends: Expensionlegends,
					slider
				} = WhiteSpace.all({
					locations,
					range: null,
					filter: null,
					legendHandler: key => {
						dispatch({ type: swtichPolygons, polygons: key });
					},
					sliderHandler: value => dispatch({ type: filterPolygons, value: { value, type: SAWhiteSpace } }),
					type: Expansion,
					tenant,
					cellSite:
						tenant === JAZZCASH
							? getLegend({
									text: CELLSITES,
									color: "#f2290f",
									onClick: () => dispatch({ type: swtichPolygons, polygons: CELLSITES })
							  })
							: null
				});

				dispatch({
					type: "setObject",
					actions: {
						set: {
							[`allPolygons.${whiteSpace}.${geo}`]: polygons,
							[`allLegends.${whiteSpace}`]: legends,
							// [`allPolygons.${SAWhiteSpace}.${geo}`]: SApolygons,
							// [`allLegends.${SAWhiteSpace}`]: SAlegends,
							[`allPolygons.${SAWhiteSpace}.${geo}`]: ExpensionPolygons,
							[`allLegends.${SAWhiteSpace}`]: Expensionlegends,
							[`allSliders.${SAWhiteSpace}.${geo}`]: slider,

							[`allPolygons.${Expansion}.${geo}`]: SApolygons,
							[`allSliders.${Expansion}.${geo}`]: SAlider,
							[`allLegends.${Expansion}`]: SAlegends,

							// [`allPolygons.${Expansion}.${geo}`]: ExpensionPolygons,
							// [`allSliders.${Expansion}`]: slider,
							// [`allLegends.${Expansion}`]: Expensionlegends,
							[`loadingsData.${geo}-${SAWhiteSpace}`]: false,
							[`loadingsData.${geo}-${whiteSpace}`]: false
						}
					}
				});
			} else {
				Error("Error While Computing White Space Polygon");
				dispatch({
					type: "setObject",
					actions: {
						set: {
							[`loadingsData.${geo}-${SAWhiteSpace}`]: undefined,
							[`loadingsData.${geo}-${whiteSpace}`]: undefined
						}
					}
				});
			}
		},
		[SAWhiteSpace]: ({ data, dispatch, geo, tenant }) => {
			if (has(data, "locations")) {
				const { locations } = data;
				const { polygons, legends } = WhiteSpace.all({
					locations,
					range: null,
					filter: null,
					legendHandler: key => {
						dispatch({ type: "FilterPolygons", value: { key, geo, selectedPolygonType: whiteSpace } });
					},
					type: whiteSpace,
					tenant
				});

				const {
					polygons: SApolygons,
					legends: SAlegends,
					slider: SAlider
				} = WhiteSpace.all({
					locations,
					range: null,
					filter: null,
					sliderHandler: value => dispatch({ type: filterPolygons, value: { value, type: Expansion } }),

					legendHandler: key => {
						dispatch({ type: swtichPolygons, polygons: key });
					},
					tenant,
					type: SAWhiteSpace
				});

				const {
					polygons: ExpensionPolygons,
					legends: Expensionlegends,
					slider
				} = WhiteSpace.all({
					locations,
					range: null,
					filter: null,
					legendHandler: key => {
						dispatch({ type: swtichPolygons, polygons: key });
					},
					sliderHandler: value => dispatch({ type: filterPolygons, value: { value, type: SAWhiteSpace } }),
					type: Expansion,
					tenant,
					cellSite:
						tenant === JAZZCASH
							? getLegend({
									text: CELLSITES,
									color: "#f2290f",
									onClick: () => dispatch({ type: swtichPolygons, polygons: CELLSITES })
							  })
							: null
				});

				dispatch({
					type: "setObject",
					actions: {
						set: {
							[`allPolygons.${whiteSpace}.${geo}`]: polygons,
							[`allLegends.${whiteSpace}`]: legends,
							// [`allPolygons.${SAWhiteSpace}.${geo}`]: SApolygons,
							// [`allLegends.${SAWhiteSpace}`]: SAlegends,
							[`allPolygons.${SAWhiteSpace}.${geo}`]: ExpensionPolygons,
							[`allLegends.${SAWhiteSpace}`]: Expensionlegends,
							[`allSliders.${SAWhiteSpace}.${geo}`]: slider,

							[`allPolygons.${Expansion}.${geo}`]: SApolygons,
							[`allSliders.${Expansion}.${geo}`]: SAlider,
							[`allLegends.${Expansion}`]: SAlegends,

							// [`allPolygons.${Expansion}.${geo}`]: ExpensionPolygons,
							// [`allSliders.${Expansion}`]: slider,
							// [`allLegends.${Expansion}`]: Expensionlegends,
							[`loadingsData.${geo}-${SAWhiteSpace}`]: false,
							[`loadingsData.${geo}-${whiteSpace}`]: false
						}
					}
				});
			} else {
				Error("Error While Computing White Space Polygon");
				dispatch({
					type: "setObject",
					actions: {
						set: {
							[`loadingsData.${geo}-${SAWhiteSpace}`]: undefined,
							[`loadingsData.${geo}-${whiteSpace}`]: undefined
						}
					}
				});
			}
		},
		[categoryWhiteSpace]: ({ data, dispatch, geo, tenant }) => {
			if (has(data, "locations")) {
				const { locations } = data;
				const { polygons, legends } = WhiteSpace.all({
					locations,
					range: null,
					filter: null,
					legendHandler: key => {
						dispatch({ type: swtichPolygons, polygons: key });
					},
					type: categoryWhiteSpace,
					tenant
				});

				const { polygons: SApolygons, legends: SAlegends } = WhiteSpace.all({
					locations,
					range: null,
					filter: null,
					legendHandler: key => {
						dispatch({ type: swtichPolygons, polygons: key });
					},
					type: CategorySAWhiteSpace,
					tenant
				});

				const {
					polygons: ExpensionPolygons,
					legends: Expensionlegends,
					slider
				} = WhiteSpace.all({
					locations,
					range: null,
					filter: null,
					legendHandler: key => {
						dispatch({ type: swtichPolygons, polygons: key });
					},
					sliderHandler: value =>
						dispatch({ type: filterPolygons, value: { value, type: CategorySAWhiteSpace } }),
					type: CategoryExpansion,
					tenant,
					cellSite:
						tenant === JAZZCASH
							? getLegend({
									text: CELLSITES,
									color: "#f2290f",
									onClick: () => dispatch({ type: swtichPolygons, polygons: CELLSITES })
							  })
							: null
				});

				const {
					polygons: CategoryExpansionCorePolygon,
					legends: CategoryExpansionCoreLegends,
					slider: CategoryExpansionCoreSlider
				} = WhiteSpace.all({
					locations,
					range: null,
					filter: null,
					legendHandler: key => {
						dispatch({ type: swtichPolygons, polygons: key });
					},
					sliderHandler: value =>
						dispatch({ type: filterPolygons, value: { value, type: CategoryExpansionCore } }),
					type: CategoryExpansionCore,
					tenant,
					cellSite:
						tenant === JAZZCASH
							? getLegend({
									text: CELLSITES,
									color: "#f2290f",
									onClick: () => dispatch({ type: swtichPolygons, polygons: CELLSITES })
							  })
							: null
				});

				dispatch({
					type: "setObject",
					actions: {
						set: {
							[`allPolygons.${categoryWhiteSpace}.${geo}`]: polygons,
							[`allLegends.${categoryWhiteSpace}`]: legends,
							// [`allPolygons.${SAWhiteSpace}.${geo}`]: SApolygons,
							// [`allLegends.${SAWhiteSpace}`]: SAlegends,
							// NEW
							[`allPolygons.${CategoryExpansionCore}.${geo}`]: CategoryExpansionCorePolygon,
							[`allLegends.${CategoryExpansionCore}`]: CategoryExpansionCoreLegends,
							[`allSliders.${CategoryExpansionCore}.${geo}`]: CategoryExpansionCoreSlider,
							[`allPolygons.${CategorySAWhiteSpace}.${geo}`]: ExpensionPolygons,
							[`allLegends.${CategorySAWhiteSpace}`]: Expensionlegends,
							[`allSliders.${CategorySAWhiteSpace}.${geo}`]: slider,

							[`allPolygons.${CategoryExpansion}.${geo}`]: SApolygons,
							// [`allSliders.${Expansion}`]: slider,
							[`allLegends.${CategoryExpansion}`]: SAlegends,

							// [`allPolygons.${Expansion}.${geo}`]: ExpensionPolygons,
							// [`allSliders.${Expansion}`]: slider,
							// [`allLegends.${Expansion}`]: Expensionlegends,
							[`loadingsData.${geo}-${CategorySAWhiteSpace}`]: false,
							[`loadingsData.${geo}-${CategoryExpansion}`]: false
						}
					}
				});
			} else {
				Error("Error While Computing White Space Polygon");
				dispatch({
					type: "setObject",
					actions: {
						set: {
							[`loadingsData.${geo}-${SAWhiteSpace}`]: undefined,
							[`loadingsData.${geo}-${whiteSpace}`]: undefined
						}
					}
				});
			}
		},
		routesData: ({ data, dispatch, geo }) => {
			let routeData = {};

			for (const key of Object.keys(data)) {
				const { population, sec } = data[key] || {};

				routeData[key] = { population, sec };
			}
			dispatch({
				type: "setObject",
				actions: {
					set: {
						[`allPolygons.${population}.${geo}`]: routeData,
						[`routesData`]: routeData,
						[`loadingsData.${geo}-${population}`]: false
					}
				}
			});
		},
		[SecPolgons]: ({ data, dispatch, geo, tenant }) => {
			const { legends, polygons } = SecPolygons.all({
				data: data,
				tenant,
				// dispatch({ type: "filterPolygons", value: { value: key, type: SecPolgons } });

				legendHandler: key => {
					dispatch({ type: "FilterPolygons", value: { key, geo, selectedPolygonType: SecPolgons } });
				}
			});
			dispatch({
				type: "setObject",
				actions: {
					set: {
						[`allPolygons.${SecPolgons}.${geo}`]: polygons,
						[`allLegends.${SecPolgons}`]: legends,
						[`loadingsData.${geo}-${SecPolgons}`]: false
					}
				}
			});
		},
		[populationDensity]: ({ data, dispatch, geo }) => {
			let polygons = PopulationHeatMap.populationDensityPolygons(data);
			dispatch({
				type: "setObject",
				actions: {
					set: {
						[`allPolygons.${populationDensity}.${geo}`]: polygons,
						[`loadingsData.${geo}-${populationDensity}`]: false
					}
				}
			});
		},
		[shopDensity]: ({ data, dispatch, geo }) => {
			let { polygons } = shopDensityMap.shopDensityPolygons({ locations: data });
			let slider = shopDensityMap.getshopDensitySlider({
				data,
				sliderHandler: value => dispatch({ type: filterPolygons, value: { value, type: shopDensity } })
			});
			dispatch({
				type: "setObject",
				actions: {
					set: {
						[`allSliders.${shopDensity}.${geo}`]: slider,

						[`allPolygons.${shopDensity}.${geo}`]: polygons,
						[`loadingsData.${geo}-${shopDensity}`]: false
					}
				}
			});
		},
		[PopulationGrids]: ({ data, dispatch, geo }) => {
			let { polygons, slider, legends } = PopulationGrid.all({
				//legends
				locations: data,
				range: null,
				filter: null,
				dispatch: dispatch,
				legendHandler: key => {
					dispatch({ type: swtichPolygons, polygons: key });
				},
				sliderHandler: value => dispatch({ type: filterPolygons, value: { value, type: PopulationGrids } }),
				type: PopulationGrids
			});

			const { type, min, max } = slider;

			dispatch({
				type: "setObject",
				actions: {
					set: {
						[`sliderValue.${type}`]: [min, max],
						[`defaultSliderValues.${type}`]: [min, max]
					}
				}
			});

			// const { min, max, type } = slider;
			dispatch({
				type: "setObject",
				actions: {
					set: {
						// [`sliderValue.${type}`]: [min, max],
						[`allSliders.${PopulationGrids}.${geo}`]: slider,
						[`allLegends.${PopulationGrids}`]: legends,
						[`allPolygons.${PopulationGrids}.${geo}`]: polygons,
						[`loadingsData.${geo}-${PopulationGrids}`]: false
					}
				}
			});
		},
		[DailyTrafficData]: ({ data, dispatch, geo }) => {
			let { polygons, slider } = DailyTrafficDataService.all({
				locations: data,
				range: null,
				filter: null,
				dispatch: dispatch,
				legendHandler: () => {},
				sliderHandler: value => dispatch({ type: filterPolygons, value: { value, type: DailyTrafficData } }),
				type: DailyTrafficData
			});

			handleSlidersValues(slider, dispatch);

			dispatch({
				type: "setObject",
				actions: {
					set: {
						[`allPolygons.${DailyTrafficData}.${geo}`]: polygons,
						[`allSliders.${DailyTrafficData}.${geo}`]: slider,
						[`loadingsData.${geo}-${DailyTrafficData}`]: false
					}
				}
			});
		},
		[digitalPersona]: ({ data, dispatch, geo }) => {
			let { polygons, slider } = DigitalPersonaDataService.all({
				locations: data,
				range: null,
				filter: null,
				legendHandler: () => {},
				sliderHandler: value => dispatch({ type: filterPolygons, value: { value, type: digitalPersona } }),
				type: digitalPersona
			});

			dispatch({
				type: "setObject",
				actions: {
					set: {
						[`allPolygons.${digitalPersona}.${geo}`]: polygons,
						[`loadingsData.${geo}-${digitalPersona}`]: false,
						[`allSliders.${digitalPersona}.${geo}`]: slider
					}
				}
			});
		},
		[TargetedConsumer]: ({ data, dispatch, geo }) => {
			let { polygons, legends, slider } = TargetedConsumerService.all({
				locations: data,
				range: null,
				filter: null,
				legendHandler: key => {
					dispatch({ type: swtichPolygons, polygons: key });
				},
				sliderHandler: value => dispatch({ type: filterPolygons, value: { value, type: TargetedConsumer } }),
				type: TargetedConsumer
			});

			dispatch({
				type: "setObject",
				actions: {
					set: {
						[`allPolygons.${TargetedConsumer}.${geo}`]: polygons,
						[`allLegends.${TargetedConsumer}`]: legends,
						[`allSliders.${TargetedConsumer}.${geo}`]: slider,
						[`loadingsData.${geo}-${TargetedConsumer}`]: false
					}
				}
			});
		},
		[demographicPopulationDensity]: ({ data, dispatch, geo }) => {
			const { polygons, slider } = DemographicPopulationDensityService.all({
				locations: data,
				range: null,
				filter: null,
				legendHandler: key => dispatch({ type: swtichPolygons, polygons: key }),
				sliderHandler: value =>
					dispatch({ type: filterPolygons, value: { value, type: demographicPopulationDensity } }),
				type: demographicPopulationDensity
			});
			handleSlidersValues(slider, dispatch);

			dispatch({
				type: "setObject",
				actions: {
					set: {
						[`allPolygons.${demographicPopulationDensity}.${geo}`]: polygons,
						[`allSliders.${demographicPopulationDensity}.${geo}`]: slider,
						[`loadingsData.${geo}-${demographicPopulationDensity}`]: false
					}
				}
			});
		},
		[additional_shops]: ({ data, dispatch, geo }) => {
			const { polygons, slider } = AdditionalShopsService.all({
				locations: data?.locations || [],
				range: null,
				filter: null,
				legendHandler: key => dispatch({ type: swtichPolygons, polygons: key }),
				sliderHandler: value => dispatch({ type: filterPolygons, value: { value, type: additional_shops } }),
				type: additional_shops
			});

			dispatch({
				type: "setObject",
				actions: {
					set: {
						[`allPolygons.${additional_shops}.${geo}`]: polygons,
						[`allSliders.${additional_shops}.${geo}`]: slider,
						[`loadingsData.${geo}-${additional_shops}`]: false
					}
				}
			});
		},
		[motor_spots]: ({ data, dispatch, geo }) => {
			const { polygons, slider } = MotorSportsServices.all({
				locations: data,
				range: null,
				filter: null,
				dispatch: dispatch,

				legendHandler: key => dispatch({ type: swtichPolygons, polygons: key }),
				sliderHandler: value => dispatch({ type: filterPolygons, value: { value, type: motor_spots } }),
				type: motor_spots
			});

			handleSlidersValues(slider, dispatch);

			dispatch({
				type: "setObject",
				actions: {
					set: {
						[`allPolygons.${motor_spots}.${geo}`]: polygons,
						[`allSliders.${motor_spots}.${geo}`]: slider,
						[`loadingsData.${geo}-${motor_spots}`]: false
					}
				}
			});
		},
		[sec_density]: ({ data, dispatch, geo }) => {
			const { polygons, legends } = SecDensityService.all({
				locations: data || [],
				range: null,
				filter: null,
				legendHandler: key => dispatch({ type: filterPolygons, value: { value: key, type: sec_density } }),
				sliderHandler: value => dispatch({ type: filterPolygons, value: { value, type: sec_density } }),
				type: sec_density
			});

			dispatch({
				type: "setObject",
				actions: {
					set: {
						[`allPolygons.${sec_density}.${geo}`]: polygons,
						[`allLegends.${sec_density}`]: legends,
						[`loadingsData.${geo}-${sec_density}`]: false
					}
				}
			});
		},
		[whiteSpace_density]: ({ data, dispatch, geo }) => {
			const { polygons, legends } = WhiteSpaveDensityService.all({
				locations: data || [],
				range: null,
				filter: null,
				legendHandler: key =>
					dispatch({ type: filterPolygons, value: { value: key, type: whiteSpace_density } }),
				sliderHandler: value => dispatch({ type: filterPolygons, value: { value, type: whiteSpace_density } }),
				type: whiteSpace_density
			});

			dispatch({
				type: "setObject",
				actions: {
					set: {
						[`allPolygons.${whiteSpace_density}.${geo}`]: polygons,
						[`allLegends.${whiteSpace_density}`]: legends,
						[`loadingsData.${geo}-${whiteSpace_density}`]: false
					}
				}
			});
		},
		[social_media_behaviors]: ({ data, dispatch, geo }) => {
			const { polygons, slider } = SocialMediaBehaviorsService.all({
				locations: data,
				range: null,
				filter: null,
				legendHandler: key => dispatch({ type: swtichPolygons, polygons: key }),
				sliderHandler: value =>
					dispatch({ type: filterPolygons, value: { value, type: social_media_behaviors } }),
				type: social_media_behaviors
			});

			handleSlidersValues(slider, dispatch);
			dispatch({
				type: "setObject",
				actions: {
					set: {
						[`allPolygons.${social_media_behaviors}.${geo}`]: polygons,
						[`allSliders.${social_media_behaviors}.${geo}`]: slider,
						[`loadingsData.${geo}-${social_media_behaviors}`]: false
					}
				}
			});
		},
		[smoking_zones]: ({ data, dispatch, geo }) => {
			const { polygons, slider } = SmokingZonesService.all({
				locations: data.locations || [],
				range: null,
				filter: null,
				legendHandler: key => dispatch({ type: swtichPolygons, polygons: key }),
				sliderHandler: value => dispatch({ type: filterPolygons, value: { value, type: smoking_zones } }),
				type: smoking_zones
			});

			handleSlidersValues(slider, dispatch);
			dispatch({
				type: "setObject",
				actions: {
					set: {
						[`allPolygons.${smoking_zones}.${geo}`]: polygons,
						[`allSliders.${smoking_zones}.${geo}`]: slider,
						[`loadingsData.${geo}-${smoking_zones}`]: false
					}
				}
			});
		}
	},
	overLapPolygons: {
		[SecPolgons]: ({ polygons, updatedpolygons, selectedGeo, sliders, legends, updatedSlider, updatedlegends }) => {
			for (let geo of selectedGeo) {
				if (has(polygons, `${defaultpolygons}`))
					updatedpolygons = { [geo]: polygons[defaultpolygons][geo], ...updatedpolygons };
			}
			updatedSlider = [updatedSlider, sliders[defaultpolygons]?.selectedGeo?.[0] || []];
			updatedlegends = [...updatedlegends, ...(legends[defaultpolygons] || [])];
			return { newPolygons: updatedpolygons, newLegends: updatedlegends, newSlider: updatedSlider };
		},
		[CELLSITES]: ({ polygons, updatedpolygons, selectedGeo, sliders, legends, updatedSlider, updatedlegends }) => {
			for (let geo of selectedGeo) {
				if (has(polygons, `${SAWhiteSpace}.${geo}`))
					updatedpolygons = { ...polygons[SAWhiteSpace][geo], ...updatedpolygons };
			}
			updatedSlider = [updatedSlider, sliders[SAWhiteSpace]?.selectedGeo?.[0] || []];
			updatedlegends = [...updatedlegends, ...(legends[SAWhiteSpace] || [])];
			return { newPolygons: updatedpolygons, newLegends: updatedlegends, newSlider: updatedSlider };
		},
		[`${Expansion}-${CELLSITES}`]: ({ updatedpolygons, _polygons }) => {
			let test = pickBy(_polygons, ({ id }) => id.startsWith(CELLSITES));

			updatedpolygons = { ...updatedpolygons, ...test };

			return { newPolygons: updatedpolygons };
		},
		[`${CELLSITES}-${CELLSITES}`]: ({
			selectedGeo,
			shopsStructure,
			updatedpolygons,
			polygons,
			sliderValue,
			shopCounts
		}) => {
			const sliderVal = sliderValue[SAWhiteSpace] || [];
			let test = {};
			let CellSiteIds = [];
			for (let geo of selectedGeo) {
				test = (polygons[SAWhiteSpace] && polygons[SAWhiteSpace][geo]) || [];
				// if (test && isEmpty(test)) break;
				let testMapping = polygons[CELLSITESMAPPING][geo];
				CellSiteIds = Object.entries(updatedpolygons).map(([, { _id }]) => _id);
				testMapping = pick(testMapping, CellSiteIds);
				testMapping = uniq(flattenDeep(Object.values(testMapping)).map(id => `Expansion Polygons-${id}`));
				mapValues(test, data => {
					let { id } = data;
					if (!testMapping.includes(id)) {
						data.style.fillColor = "#FFFFFF11";
					} else {
						if (has(data, "filterData") && !isEmpty(sliderVal)) {
							const [min, max] = sliderVal;
							let { value = 0 } = data?.filterData;

							if (value >= min && value <= max) {
								let { FoundedRange } = WhiteSpace.getColor(
									value,
									WhiteSpace.rangesAndColors.Expansions.ranges
								);
								data.style.fillColor = FoundedRange.color;
							} else data.style.fillColor = "#FFFFFF11";
						}
					}
					return data;
				});
			}

			let totalShops = [];
			let totalShopsCount = 0;
			for (let id of CellSiteIds) {
				if (shopsStructure.has(id)) {
					totalShops = uniq([...totalShops, ...shopsStructure.get(id)]);
				}
				if (shopCounts[id]) {
					totalShopsCount += shopCounts[id];
				}
			}
			updatedpolygons = { ...updatedpolygons, ...test };
			return { newPolygons: updatedpolygons, totalShops, CellSiteIds, totalShopsCount };
		},
		[`${PopulationGrids}-${PopulationGrids}`]: ({ updatedpolygons }) => {
			return { newPolygons: updatedpolygons };
		}
	},
	TENANT_PINS_COLOR: tenant => {
		const colors = {
			[SUNTORY]: "yellow",
			[BAT_MALAYSIA]: "#fd31fd"
		};

		return colors[tenant];
	},
	CENSUS_PINS_COLOR: tenant => {
		const colors = {
			[SUNTORY]: "blue"
		};
		return colors[tenant] || "blue";
	},
	ALL_TENANT_PINS_COLOR: tenant => {
		const colors = {
			[ISMAIL_INDUSTRIES]: "green"
		};
		return colors[tenant] || "orange";
	},
	checkClientFilter: (tenantFilter, selectedPolygons, tenant) => {
		const defaultTest = !isEmpty(tenantFilter) && Object.values(tenantFilter).length > 1;

		if (![PopulationGrids, SAWhiteSpace].includes(selectedPolygons)) {
			return defaultTest;
		}

		if ([PG_PHL].includes(tenant)) {
			if ([PopulationGrids, SAWhiteSpace].includes(selectedPolygons)) {
				return true;
			}
		}
		return false;
	}
};

export default obj;

export { selectedPolygonTypes, Tenant };
function handleSlidersValues(slider, dispatch) {
	if (Array.isArray(slider)) {
		slider.forEach(slider => {
			const { min, max, type, ranges } = slider;

			if (Array.isArray(ranges) && ranges.length > 0) {
				// Assuming each range object has a 'value' property that is an array,
				// we take the first value from the first range as the initial value.
				const [min, max] = ranges[0].value; // Use ranges[0].value instead of 'range'
				dispatch({
					type: "setObject",
					actions: {
						set: {
							[`sliderValue.${type}`]: [min, max],
							[`defaultSliderValues.${type}`]: [min, max]
						}
					}
				});
			} else {
				dispatch({
					type: "setObject",
					actions: {
						set: {
							[`sliderValue.${type}`]: [min, max],
							[`defaultSliderValues.${type}`]: [min, max]
						}
					}
				});
			}
		});
	} else {
		const { min, max, type } = slider;
		dispatch({
			type: "setObject",
			actions: {
				set: {
					[`sliderValue.${type}`]: [min, max],
					[`defaultSliderValues.${type}`]: [min, max]
				}
			}
		});
	}
}
